"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.BROADCAST_UPDATE_RECORDING_REALTIME = exports.BROADCAST_STOP_RECORDING = exports.BROADCAST_SAVE_RECORDING_AS_MEDIA_SOURCE = exports.BROADCAST_DOWNLOAD_LIVE_RECORDING = void 0;
var BROADCAST_DOWNLOAD_LIVE_RECORDING = exports.BROADCAST_DOWNLOAD_LIVE_RECORDING = 'BROADCAST_DOWNLOAD_LIVE_RECORDING';
var BROADCAST_SAVE_RECORDING_AS_MEDIA_SOURCE = exports.BROADCAST_SAVE_RECORDING_AS_MEDIA_SOURCE = 'BROADCAST_SAVE_RECORDING_AS_MEDIA_SOURCE';
var BROADCAST_UPDATE_RECORDING_REALTIME = exports.BROADCAST_UPDATE_RECORDING_REALTIME = 'BROADCAST_UPDATE_RECORDING_REALTIME';
var BROADCAST_STOP_RECORDING = exports.BROADCAST_STOP_RECORDING = 'BROADCAST_STOP_RECORDING';